// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".heightResponsive{height:44px !important}@media (min-width: 576px){.heightResponsive{height:46px !important}}\n", "",{"version":3,"sources":["/app/src/domain/profile/gateway/gateway.scss"],"names":[],"mappings":"AAAA,kBACI,sBAAuB,CACxB,0BAEC,kBACE,sBAAuB,CACxB","file":"gateway.scss","sourcesContent":[".heightResponsive {\n    height: 44px !important;\n  }\n  @media (min-width: 576px) {\n    .heightResponsive {\n      height: 46px !important;\n    }\n  }"]}]);
// Exports
module.exports = exports;
